import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useLenis from "@/hooks/useLenis";

export default function Layout() {
    useLenis();
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="App grain relative" data-testid="app-shell">
            <Header />
            <main className="pt-[76px]" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
